import S3ApiClient from './S3ApiClient'

const client = new S3ApiClient()

export default {
  /**
   * イベントカレンダー一覧を取得
   */
  getEventCalendars () {
    return client.get(`data/event_calendars.json?t=${new Date().getTime()}`)
  }
}
